import { render, staticRenderFns } from "./NotificationSubscriptions.vue?vue&type=template&id=12ced2cc&scoped=true&"
import script from "./NotificationSubscriptions.vue?vue&type=script&lang=js&"
export * from "./NotificationSubscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ced2cc",
  null
  
)

export default component.exports